/* eslint-disable
    eqeqeq,
*/

/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS104: Avoid inline assignments
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import _ from 'underscore';
import { Auth } from 'app/scripts/db/auth';
import { debounceSignal } from 'app/scripts/lib/util/debounce-signal';
import Hearsay from 'hearsay';

const signalCache = {};

function signalName(board, card) {
  return card ? board.id + card.cid : board.id;
}

const _pluginsChangedSignal = function (board, card) {
  const snooper = board
    .snoopIdPluginsEnabled()
    .map(function (idPlugins) {
      if (idPlugins.length === 0) {
        return Hearsay.const({});
      }

      const snoopers = idPlugins.map(function (idPlugin) {
        if (card) {
          return Hearsay.combine(
            Auth.me().snoopPluginData(idPlugin),
            board.snoopPluginData(idPlugin),
            card.snoopPluginData(idPlugin),
          );
        } else {
          return Hearsay.combine(
            Auth.me().snoopPluginData(idPlugin),
            board.snoopPluginData(idPlugin),
          );
        }
      });

      return Hearsay.combine(
        ...Array.from(snoopers || []),
      ).map((latestPluginData) => _.object(idPlugins, latestPluginData));
    })
    .latest();

  const signal = snooper.distinct(_.isEqual);

  const debouncedSignal = debounceSignal(signal, 100);

  const unuse = debouncedSignal.use();

  const stopUsing = () => {
    unuse();
    board.off('destroy', stopUsing);
    card?.off('destroy', stopUsing);
  };

  board.once('destroy', stopUsing);
  card?.once('destroy', stopUsing);

  board.on();

  return debouncedSignal;
};

const pluginsChangedSignal = function (board, card) {
  const name = signalName(board, card);
  if (!signalCache[name]) {
    signalCache[name] = _pluginsChangedSignal(board, card).addDisposer(() => {
      delete signalCache[name];
    });
  }
  return signalCache[name];
};

export { pluginsChangedSignal };
